function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:#889ccc}.cls-1{fill-rule:evenodd}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_46",
  "data-name": "Group 46",
  transform: "translate(-5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_99",
  "data-name": "Path 99",
  className: "cls-1",
  d: "M16.633.018A.5.5 0 0 1 17 .5v4a.5.5 0 0 1-1 0V2.305l-.571.952a.5.5 0 0 1-.652.19l-1.658-.829.829 1.658a.5.5 0 0 1-.224.671l-1.229.615.783.522a.5.5 0 0 1-.555.832l-1.5-1a.5.5 0 0 1 .054-.863l1.553-.776-1.277-2.553a.5.5 0 0 1 .671-.671l2.586 1.293 1.262-2.1a.5.5 0 0 1 .561-.228z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_100",
  "data-name": "Path 100",
  className: "cls-2",
  d: "M10.155 18.167H6.672l.007-1.173h3.463a2.347 2.347 0 0 1 4.555 0H15.8v-3.027l-.854-1.1h-4.56a.587.587 0 0 1-.587-.587V8.174L5.66 8.19a.587.587 0 1 1 0-1.173L10.389 7a.587.587 0 0 1 .587.587v.587h2.5A.587.587 0 0 1 14 8.5l1.763 3.5 1.094 1.409a.588.588 0 0 1 .123.36v3.811a.587.587 0 0 1-.587.587h-1.7a2.347 2.347 0 0 1-4.535 0zm1.094-.606a1.175 1.175 0 1 0 .345-.831 1.172 1.172 0 0 0-.345.831zm-.274-5.867H14.3l-1.18-2.347h-2.145z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  className: "cls-1",
  d: "M17.5 4.5A.5.5 0 0 1 18 4h4a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5zm1 .5v14h3V5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  className: "cls-2",
  d: "M48.335 353.345H46.3a.587.587 0 1 0 0 1.173h2.034a.587.587 0 1 0 0-1.173z",
  transform: "translate(-40.715 -336.352)"
}));

var SvgAccident = function SvgAccident(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.5,
    height: 20,
    viewBox: "0 0 17.5 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccident, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accident.a4890e57.svg";
export { ForwardRef as ReactComponent };